import { render, staticRenderFns } from "./custom-select-plates-dropdown-content.vue?vue&type=template&id=1dab7dd9&"
import script from "./custom-select-plates-dropdown-content.vue?vue&type=script&lang=js&"
export * from "./custom-select-plates-dropdown-content.vue?vue&type=script&lang=js&"
import style0 from "./custom-select-plates-dropdown-content.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1dab7dd9')) {
      api.createRecord('1dab7dd9', component.options)
    } else {
      api.reload('1dab7dd9', component.options)
    }
    module.hot.accept("./custom-select-plates-dropdown-content.vue?vue&type=template&id=1dab7dd9&", function () {
      api.rerender('1dab7dd9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/kit/custom-select/custom-select-plates-dropdown-content.vue"
export default component.exports